// dszImage.js — Iter 191
// Resolve a DSZ product image reference to the best available URL.
//
//   - If R2 has mirrored the image, return the public R2 URL directly
//     (fast, cached on Cloudflare edge).
//   - Otherwise return our backend image proxy so the DSZ CDN hostname
//     is never exposed to the customer.
//
// Usage:
//   import { imgSrc } from "@/lib/dszImage";
//   <img src={imgSrc(product, index)} />

const API = process.env.REACT_APP_BACKEND_URL || "";

/**
 * @param {object} product  hp_dsz_products doc (needs `sku`, `images`)
 * @param {number} index    zero-based image position (defaults 0)
 * @returns {string} best available image URL, or "" if nothing to render
 */
export function imgSrc(product, index = 0) {
  if (!product) return "";
  const imgs = product.images || [];
  const ref = imgs[index];
  if (!ref) return "";
  if (ref.r2_key && ref.public_url) return ref.public_url;
  const sku = product.sku;
  if (!sku) return ref.source_url || "";
  return `${API}/api/dsz-image-proxy/${encodeURIComponent(sku)}/${index}`;
}

/**
 * Same idea but when caller only has a single `imageRef` (not the whole
 * product) — e.g. rendering a gallery. Requires an explicit sku fallback.
 */
export function refSrc(ref, sku, index = 0) {
  if (!ref) return "";
  if (ref.r2_key && ref.public_url) return ref.public_url;
  if (!sku) return ref.source_url || "";
  return `${API}/api/dsz-image-proxy/${encodeURIComponent(sku)}/${index}`;
}
